<template>
  <div class="vehicleDispatchPage" v-if="!this.showLoad">
    <h4 class="title returnTit">车辆驾驶人员信息</h4>
    <div class="retrunMsg">
      <!-- 驾驶人 -->
      <van-cell-group class="itemPerson baseNone baseSalary beizhu moreText">
        <van-field
          v-model="driversNames"
          required
          readonly
          type="textarea"
          label="驾驶人员："
          placeholder="请选择"
          @click="checkRetinuePicker"
          is-link
          rows="1"
          autosize
          class="ggInput"
        />
      </van-cell-group>
    </div>
    <h4 class="title">车辆信息</h4>
    <div class="applyFrom">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.licensePlateNumber"
          label="车牌号："
          input-align="right"
          readonly
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.brandName"
          label="品牌："
          input-align="right"
          readonly
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.brandName"
          label="型号规格："
          input-align="right"
          readonly
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.unitCost"
          label="费用（元/公里）："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.currentMileage"
          label="当前里程（公里）："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.seatingCapacity"
          label="座位数（个）："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone summaryBox beizhu">
        <van-field
          v-model="baseData.reason"
          label="备注："
          rows="1"
          autosize
          type="textarea"
          input-align="right"
          readonly
        />
      </van-cell-group>
    </div>
    <div class="btnBox">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >车辆出库</van-button
      >
    </div>
    <!--  随行人员管理 -->
    <van-popup v-model="showRetinuePicker" position="bottom" class="roleBox">
      <retinue-view
        :retinueUids="formData.drivers"
        @setReview="setRetinue"
      ></retinue-view>
    </van-popup>
  </div>
</template>

<script>
/*eslint-disable*/
import newApi from "lodash";
const retinueView = () => import("@/components/businessTripMould/retinueView");
import { mapState, mapMutations } from "vuex";
// import { dateFormat, isEdit } from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "vehicleDispatch",
  components: {
    retinueView,
  },
  data() {
    return {
      applyId: "", //申请Id
      mode: "",
      commonId: "",
      baseData: {
        brandName: "", //品牌名称
        currentMileage: "", //当前里程数
        licensePlateNumber: "", //车牌号
        modelSpecifications: "", //型号规格
        remarks: "", //备注
        seatingCapacity: "", //座位数
        unitCost: "", //每公里收费
      },
      formData: {
        id: "", //申请id
        drivers: [], //驾驶人Id
      },
      driversNames: "", //驾驶人名称
      employMileage: "", //使用里程
      employMileageShow: false,
      showRetinuePicker: false, //随行人员弹框
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      editType: false,
      clientType: getDeviceType(), //手机类型
    };
  },
  mounted() {
    this.mode = this.$route.query.commonType;
    this.commonId = this.$route.query.commonId; //车辆详情Id
    this.applyId = this.$route.query.applyId; //申请用车的Id
    this.$set(this.formData, "id", this.applyId);

    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),

    /*点击随行人员,弹出随行人员组件*/
    checkRetinuePicker() {
      this.showRetinuePicker = true;
    },
    /*获取人员信息*/
    setRetinue(data) {
      console.log(data);
      if (data != "") {
        this.formData.drivers = data.ids;
        this.driversNames = data.names;
      }
      this.showRetinuePicker = false;
    },

    initPage() {
      let _this = this;
      _this.setShowLoad(false);
      _this.$api.material.vehicleApply
        .carDetails(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = newApi.assign({}, _this.baseData, res.data);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },

    checkInput() {
      if (this.driversNames == "") {
        this.$toast("带星号为必填项，不能为空");
      } else {
        this.saveFrom();
      }
    },
    saveFrom() {
      let _this = this;
      _this.$api.material.vehicleApply.dispatchCar(_this.formData).then((res) => {
        if (res.code == "1") {
          let text = "出库成功";
          closePage(text);
        } else {
          _this.$toast(res.msg);
        }
      });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.vehicleDispatchPage {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 5px;
    // overflow-y: initial;
  }
  .title {
    background-color: #fff;
    position: relative;
    padding: 0 16px 0 25px;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    position: relative;
    color: #2581d6;
    font-weight: 700;
    border-bottom: 1px solid #e0e0e0;
    &:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 21px;
      background: #2581d6;
      top: 12px;
      left: 16px;
    }
  }
  .title.returnTit {
    margin-top: 10px;
  }
  .baseNone::after {
    content: none;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .baseSalary {
    box-sizing: border-box;
    height: 45px;
    .ggInput {
      height: 45px;
      border-bottom: 1px solid #f6f6f6;

      /*
      .van-cell__right-icon {
        color: #000;
        margin-left: 8px;
      }*/
    }
    .van-cell:not(:last-child)::after {
      content: none;
    }
  }
  .dwBox {
    .van-cell {
      .van-cell__title {
        width: 160px;
      }
    }
  }
  .moreBox {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
}
</style>